"use client";

import { useEffect, useRef } from 'react';
import { useSupabase } from '@/lib/supabase/SupabaseProvider';
import { RealtimePostgresChangesPayload } from '@supabase/supabase-js';

export const useSubscription = (
  table: string,
  callback: (payload: RealtimePostgresChangesPayload<{ [key: string]: any }>) => void,
  events: `${"*" | "INSERT" | "UPDATE" | "DELETE"}`[] = ['*']
) => {
  const { subscribe, unsubscribe } = useSupabase();
  const callbackRef = useRef(callback);
  const eventsRef = useRef(events);
  const tableRef = useRef(table);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    eventsRef.current = events;
  }, [events]);

  useEffect(() => {
    tableRef.current = table;
  }, [table]);

  useEffect(() => {
    const channelName = 'schema-db-changes';

    // Create a stable handler function that uses refs
    const handler = (payload: RealtimePostgresChangesPayload<{ [key: string]: any }>) => {
      if (tableRef.current === '*' || payload.table === tableRef.current) {
        if (eventsRef.current.includes('*') || eventsRef.current.includes(payload.eventType as any)) {
          callbackRef.current(payload);
        }
      }
    };

    console.log(`[useSubscription] Subscribing to table: ${tableRef.current}, channel: ${channelName}`);
    subscribe(channelName, handler);

    return () => {
      console.log(`[useSubscription] Unsubscribing from table: ${tableRef.current}, channel: ${channelName}`);
      unsubscribe(channelName, handler);
    };
  }, [subscribe, unsubscribe]);
}; 